<template>
  <v-app-bar class="header-logged" app color="indigo" dark>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-app-bar-nav-icon
          v-bind="attrs"
          v-on="on"
          @click.stop="menu = !menu"
        ></v-app-bar-nav-icon>
      </template>
      <span>Menú</span>
    </v-tooltip>

    <v-navigation-drawer
      v-model="menu"
      height="610px"
      width="320px"
      app
      absolute
      temporary
    >
      <template v-slot:prepend>
        <v-list-item two-line>
          <v-list-item-avatar>
            <img src="../../../public/AvatarDr.png" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ usuario }}</v-list-item-title>
            <v-list-item-subtitle>{{ institucion }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>
      <v-list dense>
        <v-list-group
          no-action
          v-if="
            roles.some((o) => o.idRol === 1) || roles.some((o) => o.idRol === 3)
          "
          prepend-icon="mdi-calendar-clock"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Turnos</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(turno, i) in turnos"
            :key="i"
            :to="turno[1]"
            link
          >
            <v-list-item-title v-text="turno[0]"></v-list-item-title>
          </v-list-item>
          <v-list-item
            to="/BuscarTurnosEliminados"
            link
            v-if="
              roles.some((o) => o.idRol === 1) ||
              roles.some((o) => o.idRol === 12)
            "
          >
            <v-list-item-title
              v-text="'Ver Turnos Eliminados'"
            ></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group
          no-action
          v-if="roles.some((o) => o.idRol === 9)"
          prepend-icon="mdi-calendar-clock"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Turnos</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            to="/BuscarTurnos"
            link
            v-if="roles.some((o) => o.idRol === 9)"
          >
            <v-list-item-title v-text="'Buscar Turnos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group
          no-action
          v-if="
            roles.some((o) => o.idRol === 1) || roles.some((o) => o.idRol === 3)
          "
          prepend-icon="mdi-cogs"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Configuraciones</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(conf, i) in confTurnos"
            :key="i"
            :to="conf[1]"
            link
          >
            <v-list-item-title v-text="conf[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group
          no-action
          v-if="
            roles.some((o) => o.idRol === 1) || roles.some((o) => o.idRol === 8)
          "
          prepend-icon="mdi-account-multiple"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Gestión</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="(gest, i) in gestion" :key="i" :to="gest[1]" link>
            <v-list-item-title v-text="gest[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group
          no-action
          v-if="
            roles.some((o) => o.idRol === 1) || roles.some((o) => o.idRol === 4)
          "
          prepend-icon="mdi-hospital"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Historias Clínicas</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="(hc, i) in hcs" :key="i" :to="hc[1]" link>
            <v-list-item-title v-text="hc[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group
          no-action
          v-if="
            roles.some((o) => o.idRol === 1) ||
            roles.some((o) => o.idRol === 10)
          "
          prepend-icon="mdi-needle"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Enfermería</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(enf, i) in enfermeria"
            :key="i"
            :to="enf[1]"
            link
          >
            <v-list-item-title v-text="enf[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group
          no-action
          v-if="
            roles.some((o) => o.idRol === 1) ||
            roles.some((o) => o.idRol === 11)
          "
          prepend-icon="mdi-ambulance"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Traslados</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="(tra, i) in traslados" :key="i" :to="tra[1]" link>
            <v-list-item-title v-text="tra[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group
          no-action
          v-if="cajasVisibles.length > 0"
          prepend-icon="mdi-currency-usd"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Caja</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(caja, i) in cajasVisibles"
            :key="i"
            :to="caja[1]"
            link
          >
            <v-list-item-title v-text="caja[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>

        <v-list-group
          no-action
          v-if="
            roles.some((o) => o.idRol === 1) ||
            roles.some((o) => o.idRol === 13)
          "
          prepend-icon="mdi-package-variant"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Stock</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="(tra, i) in stock" :key="i" :to="tra[1]" link>
            <v-list-item-title v-text="tra[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>

        <v-list-group
          no-action
          v-if="
            roles.some((o) => o.idRol === 1) ||
            roles.some((o) => o.idRol === 3)
          "
          prepend-icon="mdi-clipboard-list"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Circuitos</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(circ, i) in circuitos"
            :key="i"
            :to="circ[1]"
            link
          >
            <v-list-item-title v-text="circ[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>

        <v-list-group
          no-action
          v-if="
            (roles.some((o) => o.idRol === 1) ||
              roles.some((o) => o.idRol === 7)) &&
            !this.$store.state.usuario.institucion.esEmpresa
          "
          prepend-icon="mdi-chart-bar"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Estadísticas</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(est, i) in estadisticasVisibles"
            :key="i"
            :to="est[1]"
            link
          >
            <v-list-item-title v-text="est[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
          no-action
          v-if="this.$store.state.usuario.institucion.esEmpresa"
          prepend-icon="mdi-chart-bar"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Estadísticas</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="(est, i) in reportes" :key="i" :to="est[1]" link>
            <v-list-item-title v-text="est[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>

        <v-list-group
          no-action
          v-if="
            roles.some((o) => o.idRol === 1) || roles.some((o) => o.idRol === 6)
          "
          prepend-icon="mdi-key-variant"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Cuenta</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="(conf, i) in confs" :key="i" :to="conf[1]" link>
            <v-list-item-title v-text="conf[0]"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn @click="logout()" block>
            <v-icon left>mdi-power-standby</v-icon>
            Cerrar Sesión</v-btn
          >
        </div>
      </template>
    </v-navigation-drawer>
    <v-divider vertical></v-divider>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="ml-3" icon small v-bind="attrs" v-on="on" to="/Home">
          <v-icon>mdi-home</v-icon>
        </v-btn>
      </template>
      <span>Página de Inicio</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="ml-2"
          icon
          x-small
          v-bind="attrs"
          v-on="on"
          @click="cambiarContrasena"
        >
          <v-icon>mdi-wrench</v-icon>
        </v-btn>
      </template>
      <span>Cambiar Contraseña</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="ml-2" v-bind="attrs" v-on="on" icon small @click="logout">
          <v-icon>mdi-power-standby</v-icon>
        </v-btn>
      </template>
      <span>Cerrar Sesión</span>
    </v-tooltip>
    <v-spacer></v-spacer>
    <span class="mr-6">
      <v-menu offset-y class="notification-menu">
        <template v-slot:activator="{ on, attrs }">
          <v-badge
            :content="
              getListaRecordatorios.filter((item) => !item.leido).length
            "
            color="red"
            overlap
            :class="{
              notification: true,
              'sin-notificaciones': !getListaRecordatorios.filter(
                (item) => !item.leido,
              ).length,
            }"
          >
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-bell</v-icon>
            </v-btn>
          </v-badge>
        </template>

        <v-card min-width="300" class="notification-card">
          <v-list>
            <template v-if="getListaRecordatorios.length">
              <div
                class="notification-list"
                style="overflow-y: auto; max-height: 500px"
              >
                <v-list-item
                  v-for="(notification, index) in getListaRecordatorios"
                  :key="index"
                  :class="{ 'no-leido': !notification.leido }"
                  @click="openNotification(notification)"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{
                      notification.titulo
                    }}</v-list-item-title>
                    <v-list-item-subtitle class="text-truncate">
                      {{ notification.texto }}
                      <v-row v-if="notification.usuarioCreador">
                        <v-col cols="12">
                          <span>
                            Notificacion creada por:
                            {{ notification.usuarioCreador }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click.stop="openNotification(notification)">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </div>
            </template>
            <v-list-item v-else>
              <v-list-item-content>
                <v-list-item-title
                  style="text-align: center; font-size: 1rem; font-weight: 600"
                >
                  No hay notificaciones
                </v-list-item-title></v-list-item-content
              >
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title
                  style="text-align: center; font-size: 1rem; font-weight: 600"
                >
                  <v-btn
                    color="warning"
                    @click="
                      $router.push({
                        name: 'Recordatorios',
                        params: { notifica: true },
                      })
                    "
                    >Crear Notificación</v-btn
                  >
                </v-list-item-title></v-list-item-content
              >
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </span>
    <span class="app-version">v.{{ $appVersion }}</span>
    <router-link to="/Home">
      <v-img
        src="../../assets/isologo.png"
        max-height="50"
        max-width="150"
        contain
      ></v-img>
    </router-link>

    <CambiarContrasena
      :visible="showCambiarContrasena"
      :usuario="usuario"
      @close="showCambiarContrasena = false"
    ></CambiarContrasena>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>{{ selectedNotification.titulo }}</v-card-title>
        <v-card-text>
          {{ selectedNotification.texto }}
          <v-row v-if="selectedNotification.usuarioCreador">
            <v-col cols="12">
              Notificación creada por: {{ selectedNotification.usuarioCreador }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
import CambiarContrasena from "../Cuenta/CambiarContrasena.vue";
import { mapGetters, mapMutations } from "vuex";
import axios from "../../axios-auth.js";

export default {
  data() {
    return {
      dialog: false,
      selectedNotification: {},
      showCambiarContrasena: false,
      menu: false,
      turnos: [
        ["Agenda Diaria", "/GestionTurnos"],
        ["Agenda Semanal (Grilla)", "/GestionTurnosSemanaWide"],
        ["Agenda Semanal (Lista)", "/GestionTurnosSemana"],
        ["Turnos por Servicio", "/TurnosPorServicio"],
        ["Buscar Turnos", "/BuscarTurnos"],
      ],
      confTurnos: [
        ["Cronogramas", "/Cronogramas"],
        ["Feriados y Cancelaciones", "/Feriados"],
        [
          `Topes y Precios Consulta por ${
            this.$store.state.usuario.institucion.esEmpresa ? "Sede" : "O.S"
          }`,
          "/Topes",
        ],
        ["Tipos de Turno", "/TiposTurno"],
      ],
      gestion: [
        ["Profesionales", "/Profesionales"],
        [
          `${
            this.$store.state.usuario.institucion.esEmpresa
              ? "Sedes"
              : "Obras Sociales"
          }`,
          "/ObrasSociales",
        ],
        ["Consultorios y Salas de Espera", "/ConsultoriosSalasEspera"],
        ["Instituciones Externas", "/InstitucionesExternas"],
        ["Pacientes", "/Pacientes"],
      ],
      hcs: [
        ["Ver Historias Clínicas", "/HistoriasClinicas"],
        ["Gestión de Pacientes", "/Pacientes"],
        ["Plantillas de Pedidos", "/Plantillas"],
        ["Listado de Archivos", "/ListadoInformes"],
        ["Listado de Evoluciones", "ListadoEvoluciones"],
        ["Gestión de Pestañas de HC", "/HcTabs"],
      ],
      cajas: [
        ["Gestión de Movimientos de Caja", "/Cobros"],
        ["Liquidación a Profesionales", "/Liquidacion"],
        ["Cierre de Caja", "/CierreCaja"],
        ["Presupuestos (Tratamientos)", "/Presupuestos"],
      ],
      estadisticas: [
        ["Dashboard", "/Dashboard"],
        ["Tiempos de Atención", "/TiemposAtencion"],
      ],
      reportes: [["Reportes", "/Reportes"]],
      confs: [
        ["Configurar Institución", "/ConfCuenta"],
        ["Gestión de Usuarios", "/Usuarios"],
        ["Agregar Logo y Foto", "/LogoFoto"],
      ],
      enfermeria: [
        ["Panel de Enfermería", "/Enfermeria"],
        ["Gestión de Vacunas", "/Vacunas"],
        ["Gestión de Enfermeros", "/Enfermeros"],
      ],
      traslados: [
        ["Gestión de Traslados", "/Traslados"],
        ["Gestión de Choferes", "/Choferes"],
      ],
      stock: [
        ["Gestión de Productos", "/Productos"],
        ["Historial de Consumos", "/HistorialConsumos"],
      ],
      circuitos: [
        ["Configurar Circuitos", "/CircuitosConfig"],
        ["Dashboard Circuitos", "/DashboardCircuitos"],
      ],
      group: null,
      usuario: null,
      institucion: null,
      roles: [],
      permiteCrearProfesionales: false,
    };
  },
  computed: {
    ...mapGetters(["getListaRecordatorios"]),
    // Solo el Administrador_Institucion (rol id 1) puede ver el reporte de
    // Tiempos de Conexión (Req 8.3).
    esAdministrador() {
      return this.roles.some((o) => o.idRol === 1);
    },
    // Filtra los ítems de Estadísticas: "Tiempos de Conexión" queda oculto para
    // usuarios sin rol de administrador. El resto (p. ej. Dashboard) sigue
    // visible para su audiencia actual (Req 8.3).
    estadisticasVisibles() {
      return this.estadisticas.filter(
        (est) => est[1] !== "/TiemposAtencion" || this.esAdministrador
      );
    },
    // Rol Caja Limitada (idRol 15): acceso reducido al módulo de Caja. Solo aplica
    // el recorte cuando el usuario NO tiene además un rol de Caja completo (1 o 5).
    esCajaLimitada() {
      return (
        this.roles.some((o) => o.idRol === 15) &&
        !this.roles.some((o) => o.idRol === 1) &&
        !this.roles.some((o) => o.idRol === 5)
      );
    },
    // Única fuente de verdad de los ítems del menú Caja, unificando todos los
    // roles en un solo grupo (evita que aparezcan dos menús "Caja" cuando un
    // usuario combina roles, p. ej. Caja Limitada + Presupuestos).
    // - Caja completa (rol 1 o 5): todas las opciones.
    // - Caja Limitada (rol 15): "Gestión de Movimientos de Caja" y "Liquidación
    //   a Profesionales"; además "Presupuestos" si también tiene el rol 14.
    // - Presupuestos (rol 14): solo "Presupuestos (Tratamientos)".
    cajasVisibles() {
      const tieneCajaCompleta =
        this.roles.some((o) => o.idRol === 1) ||
        this.roles.some((o) => o.idRol === 5);

      if (tieneCajaCompleta) {
        return this.cajas;
      }

      const rutasPermitidas = new Set();
      if (this.roles.some((o) => o.idRol === 15)) {
        rutasPermitidas.add("/Cobros");
        rutasPermitidas.add("/Liquidacion");
      }
      if (this.roles.some((o) => o.idRol === 14)) {
        rutasPermitidas.add("/Presupuestos");
      }

      // Se filtra sobre `cajas` para preservar el orden y las etiquetas originales.
      return this.cajas.filter((caja) => rutasPermitidas.has(caja[1]));
    },
  },
  watch: {
    group() {
      this.drawer = false;
    },
  },
  methods: {
    ...mapMutations(["marcarComoLeido"]),
    async openNotification(notification) {
      this.marcarComoLeido(notification.idRecordatorio);
      await axios.get("/Usuario/MarcarRecordatorioComoLeido", {
        params: {
          idRecordatorio: notification.idRecordatorio,
          usuario: this.$store.state.usuario.usuario,
        },
      });
      this.selectedNotification = notification;
      this.dialog = true;
    },
    logout() {
      this.$store.dispatch("logout");
    },
    cambiarContrasena() {
      this.showCambiarContrasena = true;
    },
  },
  created() {
    this.usuario = this.$store.state.usuario.usuario.toString().trim();
    this.institucion = this.$store.state.usuario.institucion.nombreInstitucion
      .toString()
      .trim();
    this.roles = this.$store.state.usuario.roles;
    this.permiteCrearProfesionales =
      this.$store.state.usuario.institucion.permiteCrearProfesionales;
  },
  components: {
    CambiarContrasena,
  },
};
</script>
<style scoped>
.app-version {
  color: white;
  font-size: 0.75rem;
  margin-right: 1.5rem;
}
::v-deep .notification .v-badge__badge {
  inset: auto auto calc(100% - 16px) calc(100% - 22px) !important;
  width: 20px;
  text-align: center;
  padding: 4px 2.5px;
}

::v-deep .notification.sin-notificaciones .v-badge__badge {
  visibility: hidden;
}

::v-deep .notification-card .v-list {
  width: 500px;
}

::v-deep .notification-card .v-list-item.no-leido {
  background-color: #e8e8e8;
}

::v-deep .notification-card .v-list-item {
  cursor: pointer;
}

::v-deep .notification-card .v-list-item:not(:last-child) {
  border-bottom: 0.8px solid lightgray;
}
.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;
}
</style>
